<template>
  <div class="container">
    <div id="div_banner" class="banner1">
      <img src="../../assets/20170510155226_7777.jpg" alt="新闻中心Banner">
    </div>
    <div id="div_newsContent" class="n1">
      <div class="box">
        <div class="top">
          <h1>{{trendsDetail.ftitle}}</h1>
          <div class="clearfix">
            <span>发布时间：{{trendsDetail.freleaseDate}}</span>
            <span>信息来源：</span><span class="span3">浏览次数：0</span>
          </div>
        </div>
      <div class="main1">
        <div class="pic_box">
        <img :src="baseUrl + trendsDetail.fimgUrl" alt="义乌市委常委、副市长王新峰一行莅临公司调研指导">
       </div>
        <div class="text" v-html="trendsDetail.fcontent">
        </div>
      </div>
      <div class="bom clearfix">
        <div class="fl">
          <router-link v-if="first" :to="{path: '/trendDetail',query:{id:first.fnewsId}}" @click.native="flushCom" class="prev">上一篇：{{first.ftitle}}</router-link>
          <router-link v-if="end" :to="{path: '/trendDetail',query:{id:end.fnewsId}}" @click.native="flushCom" class="prev">下一篇：{{end.ftitle}}</router-link>
        </div>
        <a @click="back" class="more fr">返回列表</a>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  import axios from '../../../static/js/commonAxios'
    export default {
        name: "trend-detail",
      data(){
          return{
            trendsDetail:'',
            id:this.$route.query.id,
            baseUrl:'',
            first:'',
            end:''
          }
      },
      mounted(){
        this.baseUrl = process.env.API_ROOT;
        this.getTrendDetailDate(this.id)
      },
      methods:{
        back(){
          this.$router.go(-1);
        },
        flushCom(){
          this.$router.go(0);
        },
        getTrendDetailDate(id){
          axios.get(`/api/selectNews`,{
            'params':{
              "fnewsId":id
            }
          }).then((res) => {
            if(res.data.success){
              this.trendsDetail = res.data.items[0]
              console.log('新闻详情');
              if(this.trendsDetail.fnewsType ==='G'){
                this.getTrendsDate(this.trendsDetail.fnewsId,'G')
              }else{
                this.getTrendsDate(this.trendsDetail.fnewsId,'H')
              }
              console.log(this.trendsDetail );
            }else{
              this.$message({
                type: 'warning',
                message: res.data.msg
              });
            }
          })
        },
        getTrendsDate(id,type){
          let i
          axios.get(`/api/newsPage?page=1&limit=100&fnewsType=${type}`).then((res) => {
            if(res.data.success){
              console.log(res.data);
              res.data.items.forEach((res,index)=>{
                if(res.fnewsId === id){
                  console.log(index);
                  i = index
                }
              })
              console.log(i);
              this.first = res.data.items[i-1]
              this.end = res.data.items[i+1]
              console.log('第一条');
              console.log(this.first);
              console.log('第而条');
              console.log(this.end);
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
      }
    }
</script>

<style scoped>
  .n1{
    width: 100%;
    padding-top: 65px;
    padding-bottom: 80px;
  }
  .n1 .top{
    width: 1000px;
    margin: 0 auto;
    text-align: center;
    padding-bottom: 20px;
    border-bottom: 1px dashed #ccc;
  }

  .n1 .top h1{
    font-size: 24px;
    color: #000;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .n1 .top div span{
    font-size: 12px;
    color: #888;
    margin-right: 15px;
  }
  .n1 .top div .span3{
    margin-right: 0;
  }
  .n1  .main1{
    width: 100%;
    padding-top: 30px;
  }
  .n1  .main1 .pic_box{
    width: 860px;
    overflow: hidden;
    margin:  0 auto;
  }
  .n1  .main1 .pic_box img{
    display: block;
    width: 100%;
  }
  .n1  .main1 .text{
    font-size: 14px;
    color: #333;
    line-height: 30px;
    width: 860px;
    overflow: hidden;
    margin:  20px auto 0;
  }
  .n1  .main1 .text p img{
    display: block;
    margin: 0 auto;
  }
  .n1 .bom{
    width: 860px;
    overflow: hidden;
    margin:  20px auto 0;
    padding-top: 20px;
    border-top: 1px solid #ccc;
  }
  .n1 .bom div a{
    display: block;
    font-size: 12px;
    color: #808080;
    line-height: 30px;
    text-decoration: none;
  }
  .n1 .bom div a:hover{
    color: #333;
  }
  .n1 .bom .more{
    width: 140px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    background: #555;
    color: #fff;
    border-radius: 8px;
    text-decoration: none;
  }
  .n1 .bom .more:hover{
    background: #333;
  }
</style>



// WEBPACK FOOTER //
// src/components/trends/trendDetail.vue